import { ApiType } from '../models/types';
import { firebaseApi } from './firebaseConfig';

export const Api: ApiType = firebaseApi;